/*
 * @author Maksym Shutiak <maxshutyak>
 */
const gccsPlanningTutorialSearch = {
  template: require('./template.pug')
};

angular.module('public.security-manager.schedule-manager.timeline.planning')
  .component('gccsPlanningTutorialSearch', gccsPlanningTutorialSearch);
